
import { Box, useTheme, ButtonBase } from "@mui/material";
import { tokens } from "../../../../../theme";

import AddIcon from '@mui/icons-material/Add';
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from 'react-i18next';
import MAddConceptInvoice from "../../../../../components/global/Modals/MAddConceptInvoice";
import ButtonGroup from "../../../../../components/theme/buttons/ButtonGroup";
import Shbutton from "../../../../../components/theme/buttons/Shbutton";
import ShDataGrid2 from "../../../../../components/theme/datagrid2/ShDataGrid2";
import ShLabel from "../../../../../components/theme/label/ShLabel";
import ShLabelSkeleton from "../../../../../components/theme/skeleton/ShLabelSkeleton";
import ShTextSkeleton from "../../../../../components/theme/skeleton/ShTextSkeleton";
import Text from "../../../../../components/theme/text/Text";
import { useGetReturnsWithoutSendingCostsQuery, useRecalculateOrderCostsMutation, useCalculateReturnCostsMutation } from "../../../../../newapi/financial/invoiceSlice";
import { general_states } from "../../../../../utils/staticEnums";
// import SpRelationDetails from "../../../../../components/global/Sidepanels/SpRelationDetails/SpRelationDetails";
// import SpInvoiceDetails from "../../../../../components/global/Sidepanels/SpInvoiceDetails/SpInvoiceDetails";
import ShDataGridSelectedActions from "../../../../../components/theme/datagrid2/ShDataGridSelectedActions";
import { WarehouseInvoiceCard } from "../../../../../components/global/cards/financial/InvoiceCard";
import SidepanelLoader from "../../../../../components/theme/sidepanel2/SidepanelLoader";
import { formatPrice } from "../../../../../utils/helpers";
import { getInvoiceStateData } from "../../../../../utils/labelColorText";
import { selectUserPermission } from "../../../../../newapi/user/authentication/authSlice";
import { UserPrivileges } from '../../../../../utils/permissions';
import { useSelector } from "react-redux";
import { INVOICE_FILTER_KEYS, INVOICE_WITHOUT_COST_KEYS } from "../../../../../components/global/DataGrid/Filter";
import MConfirmation from '../../../../../components/global/Modals/MConfirmation';
import MLoader from "../../../../../components/global/Modals/MLoader";
import MSplitReturnWeight from "../../../../../components/global/Modals/MSplitReturnWeight";
import DropdownButton from "../../../../../components/theme/buttons/DropdownButton";
import CalculateIcon from '@mui/icons-material/Calculate';
import { showToastMessage, showToastMessageRequestError, showToastMessageUpdateRequest } from "../../../../../utils/toasts";
import { endOfMonth, startOfMonth, subDays, subMonths } from "date-fns";
import { format } from "date-fns";

const SpRelationDetails = SidepanelLoader(() => import("../../../../../components/global/Sidepanels/SpRelationDetails/SpRelationDetails"));
const SpOrderDetails = SidepanelLoader(() => import("../../../../../components/global/Sidepanels/SpOrderDetails/SpOrderDetails"));
const SpReturnDetails = SidepanelLoader(() => import("../../../../../components/global/Sidepanels/SpReturnDetails/SpReturnDetails"));

const GridActions = (props) => {
    const theme = useTheme();
    const {t} = useTranslation();
    return (
        <ButtonGroup version={2}></ButtonGroup>
    )
}

let gridOptions = {
    export:true,
    disableCustomActionsOnPhone: true,
    isSidepanel: true,
    filter: [
        INVOICE_WITHOUT_COST_KEYS.DATERANGE
    ],
};

const All = (props) => {
    const { t, i18n } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [data, setData] = useState([]);
    const [isExtended, setIsExtended] = useState(false);
    const [spLoading, setSpLoading] = useState();

    const [isRelationExtended, setIsRelationExtended] = useState(false);
    const [spRelationLoading, setSpRelationLoading] = useState();

    const [isReturnExtended, setIsReturnExtended] = useState(false);
    const [spReturnLoading, setSpReturnLoading] = useState();
    
    const ref = useRef();
    const [config, setConfig] = useState({
        "state": general_states.ACTIVE,
        date: {
            startDate: format(startOfMonth(subMonths(new Date(), 6)), 'yyyy-MM-dd'),
            endDate: format(subDays(new Date(), 2), 'yyyy-MM-dd') // yesterday
          }
    });

    const hasModifyPrivilege = useSelector((state) => 
        selectUserPermission(state, [UserPrivileges.INVOICE_ORDERSWITHOUTCOST_MANAGE])
    );
    
    const [selectedItems, setSelectedItems] = useState([]);
    const onSelected = (selectedItems) => {
        setSelectedItems(selectedItems);
    }

    useEffect(() => {
        props.replaceView({
            ...props.config,
            gridOptions: gridOptions,
        });

        return () => {
        }
    },[]);

    const [relationId, setRelationId] = useState();
    const relationIdRef = useRef(relationId);
    
    const getRelationDetails = (params) => {
        if (!params && params.row) return;
    
        const newRelationId = parseInt(params.row.relationId);
        // Only update state if the productId has actually changed
        if (relationIdRef.current !== newRelationId) {
            if(!spRelationLoading) {
                setSpRelationLoading(true);
            }
            setRelationId(newRelationId);
            relationIdRef.current = newRelationId; // Update the ref to the new value
        }
        setIsRelationExtended(true);
    };
    
    const [confirmModalOpen, setConfirmModalOpen] = useState(false);
    const confirmModal = {
        open: confirmModalOpen,
        setOpen: setConfirmModalOpen,
    };

    const handleConfirmModalClose = () => {
        confirmModal.setOpen(false);
    };

    const [calculateModalOpen, setCalculateModalOpen] = useState(false);
    const calculateModal = {
        open: calculateModalOpen,
        setOpen: setCalculateModalOpen,
    };

    const handleCalculateModalClose = () => {
        calculateModal.setOpen(false);
    };

    // Return whose weight is being split over its parcels, null when the modal is closed
    const [splitWeightReturn, setSplitWeightReturn] = useState(null);

    const [loaderModalOpen, setLoaderModalOpen] = useState(false);
    const loaderModal = {
        open: loaderModalOpen,
        setOpen: setLoaderModalOpen,
    };

    const [orderId, setOrderId] = useState();
    const orderIdRef = useRef(orderId);
    
    const getOrder = (params) => {
        if (!params) return;
    
        const newOrderId = parseInt(params.row.orderId);
        // Only update state if the pickingJobListId has actually changed
        if (orderIdRef.current !== newOrderId) {
            if(!spLoading) {
                setSpLoading(true);
            }
            setOrderId(newOrderId);
            orderIdRef.current = newOrderId; // Update the ref to the new value
        }
        setIsExtended(true);
    };

    const [returnId, setReturnId] = useState();
    const returnIdRef = useRef(orderId);
    
    const getReturn = (params) => {
        if (!params) return;
    
        const newReturnId = parseInt(params.row.id);
        // Only update state if the pickingJobListId has actually changed
        if (orderIdRef.current !== newReturnId) {
            if(!spLoading) {
                setSpReturnLoading(true);
            }
            setReturnId(newReturnId);
            orderIdRef.current = newReturnId; // Update the ref to the new value
        }
        setIsReturnExtended(true);
    };

    const [recalculateOrders, {isLoading: recalculateLoading}] = useRecalculateOrderCostsMutation();
    const handleRecalculateOrders = async() => {
        try {
            if (recalculateLoading) return;
            const response = await recalculateOrders({orderIds:selectedItems}).unwrap();
            showToastMessageUpdateRequest(t, response);
        } catch (e) {
            showToastMessageRequestError(t('update_failed'), t, e);
        }
    }

    const [calculateReturnCosts, {isLoading: calculateLoading}] = useCalculateReturnCostsMutation();
    const handleCalculateReturnCosts = async() => {
        try {
            if (calculateLoading) return;

            loaderModal.setOpen(true);

            const response = await calculateReturnCosts({returnIds:selectedItems}).unwrap();

            // Returns without a rate for every parcel are not booked and stay in the overview
            const notCalculated = response.notCalculatedReturnIds?.length ?? 0;
            if (notCalculated > 0) {
                showToastMessage("warning", t("returns_not_calculated", { count: notCalculated, total: selectedItems.length }));
            } else {
                showToastMessageUpdateRequest(t, response);
            }
        } catch (e) {
            showToastMessageRequestError(t('update_failed'), t, e);
        } finally {
            loaderModal.setOpen(false);
        }
    }

    const columns = [
        {field: "relationName", headerName: t("relation"),flex:1, 
            filter: INVOICE_FILTER_KEYS.RELATION,
        renderCell: (params) => {
            if(params.row.skeleton) {
                return <ShTextSkeleton/>
            }
            const handleClick = (event) => {
                event.stopPropagation(); // Prevent click from propagating to the row
                getRelationDetails(params);
            };
            return (
                <Box sx={{height:1,display:"flex",alignItems:'center'}} onClick={handleClick}>
                    <Text bold clickable={true} variant={theme.palette.mode === "dark" ? "blue" : "primary"}>{params.row.relationName}</Text>
                </Box>
            );
        }},
        {
            field: "returnReference",
            headerName: t("return"),
            flex:1,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
            if(params.row.skeleton) {
                return <ShTextSkeleton/>
            }
            const handleClick = (event) => {
                event.stopPropagation(); // Prevent click from propagating to the row
                getReturn(params);
            };
            return (
                <Box sx={{height:1,display:"flex",alignItems:'center'}} onClick={handleClick}>
                    <Text bold clickable={true} variant={theme.palette.mode === "dark" ? "blue" : "primary"}>{`${params.row.returnReference} (${params.row.orderCountry.toUpperCase()})`}</Text>
                </Box>
            );
            }
        },
        {
            field: "orderBarcode",
            headerName: t("order"),
            flex:1,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
            if(params.row.skeleton) {
                return <ShTextSkeleton/>
            }
            const handleClick = (event) => {
                event.stopPropagation(); // Prevent click from propagating to the row
                getOrder(params);
            };
            return (
                <Box sx={{height:1,display:"flex",alignItems:'center'}} onClick={handleClick}>
                    <Text bold clickable={true} variant={theme.palette.mode === "dark" ? "blue" : "primary"}>{`${params.row.orderBarcode} (${params.row.orderCountry.toUpperCase()})`}</Text>
                </Box>
            );
            }
        },
        {
            field: "date", 
            headerName: t("date_sent"),
            flex:1,
            shFilter: {
                type: "date"
            },
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                return (
                    <Text>
                        {new Date(params.row.shipmentCreatedAt).toLocaleDateString(i18n.language)}
                    </Text>
                );
            }
        },
        {
            field: "shipperName", 
            headerName: t("shipper"),
            flex:1,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                return params.row.shipperProfileName;
            }
        },
        {
            field: "shipmentCount",
            headerName: t("shipments"),
            flex:1,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                // Several parcels are only rated after a user splits the return weight over them
                if (params.row.shipmentCount > 1 && hasModifyPrivilege) {
                    const handleClick = (event) => {
                        event.stopPropagation(); // Prevent click from propagating to the row
                        setSplitWeightReturn(params.row);
                    };
                    return (
                        <Box sx={{height:1,display:"flex",alignItems:'center',gap:1}} onClick={handleClick}>
                            <Text>{params.row.shipmentCount}</Text>
                            <Text bold clickable={true} variant={theme.palette.mode === "dark" ? "blue" : "primary"}>{t("split_return_weight")}</Text>
                        </Box>
                    );
                }

                return params.row.shipmentCount;
            }
        },
        {
            field: "weightAndVolume",
            headerName: t("weight_kg_slash_volume_l"),
            flex:1,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShLabelSkeleton/>
                }

                // Weight of the return itself; unknown when a returned product has no weight
                const weight = params.row.returnWeight !== null && params.row.returnWeight !== undefined
                    ? `${parseFloat(parseInt(params.row.returnWeight) / 1000)}kg`
                    : "-";
                return `${weight} / ${parseInt(params.row.returnVolume ?? 0)}L`;
              }
        }
        // {
        //     field: "phoneView", 
        //     headerName: "PhoneView",
        //     cellClassName: "phone-column--cell",
        //     renderCell: (params) => {
        //         // WarehouseInvoiceCard
        //         return (
        //             <WarehouseInvoiceCard
        //                 onClick={() => getInvoice(params)}
        //                 skeleton={params.row.skeleton}
        //                 {...params.row}
        //             />
        //             // <ShTextSkeleton/>
        //         )
        //     }
        // },
    ];

    return (
        <Box height={1} ref={ref} display={"flex"} flexDirection={"column"}>
            {/* <GridActions></GridActions> */}
            <ShDataGrid2 key={theme.palette.mode}
                content={useGetReturnsWithoutSendingCostsQuery}
                config={config}
                gridActions={<GridActions></GridActions>} 
                title={t('all')}
                gridOptions={gridOptions} 
                sortModel={{field: columns[0].field,type:"DESC"}}
                columns={columns}
                rows={data}

                selectable={hasModifyPrivilege}
                setSelected={hasModifyPrivilege ? onSelected : undefined}
                selectedItems={hasModifyPrivilege ? selectedItems: undefined}

                selectedActions={
                    hasModifyPrivilege &&
                    <ShDataGridSelectedActions selectedItems={selectedItems}>
                        <DropdownButton onClick={() => calculateModal.setOpen(true)} icon={<CalculateIcon/>} text={t("recalculate_invoice_product")}/>
                    </ShDataGridSelectedActions>
                }
            >
            </ShDataGrid2>

            <MConfirmation
                open={confirmModal.open}
                handleClose={handleConfirmModalClose}
                title={t("mc_order_to_ship_title")}
                subtitle={t("mc_order_to_ship_subtitle")}
                confirm={() => handleRecalculateOrders()}
            />

            <MConfirmation
                open={calculateModal.open}
                handleClose={handleCalculateModalClose}
                title={t("calculate_order_costs")}
                content={t("are_you_sure_you_want_to_calculate_the_costs")}
                confirm={() => handleCalculateReturnCosts()}
            />

            <MSplitReturnWeight
                open={splitWeightReturn !== null}
                returnData={splitWeightReturn}
                handleClose={() => setSplitWeightReturn(null)}
            />

            <MLoader
                open={loaderModal.open}
                message={t("calculating_order_costs")}
            />

            {spRelationLoading && 
                <SpRelationDetails
                    relationId={relationId}
                    isExtended={isRelationExtended}
                    setIsExtended={setIsRelationExtended}
                    // data={pickingJobData}
                /> 
            }

            {spLoading && 
                <SpOrderDetails
                    orderId={orderId}
                    isExtended={isExtended}
                    setIsExtended={setIsExtended}
                    // data={pickingJobData}
                /> 
            }

            {spReturnLoading && 
                <SpReturnDetails
                    returnId={returnId}
                    isExtended={isReturnExtended}
                    setIsExtended={setIsReturnExtended}
                    // data={pickingJobData}
                /> 
            }
        </Box>
    );
}

export default All;